import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { confirmAlert } from 'react-confirm-alert';
import { OverlayTrigger, Tooltip, Row, Col, Modal } from 'react-bootstrap'

//components
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '~/hoc/withLocalization';
import withRemoveDialog from '~/hoc/withRemoveDialog';
import Button from '../../../components/CustomButton/CustomButton.jsx';
import GenericFilter from '../../../components/GenericList/GenericFilter.js';
import GenericList from '~/components/GenericList/GenericList';
import ImportTaskFromIntegration from './ImportTaskFromIntegration';

//utils
import { shortDateFormat, totalTimeFormat } from '~/utils/dateFormat';
import customerFeature from '~/utils/customerFeature';
import { checkUserPermissions } from '../../../library/stores/userStore.js';
import { payrollIntegrationOptions } from '../../../utils/constants.js';

//assets
import Edit from '../../../assets/img/editing.svg';
import Delete from '../../../assets/img/deleting.svg';
import Sync from '../../../assets/img/Sync.svg'
import { getIntegrationProduct } from '../../../utils/integrationUtils.js';
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg'
import TaskMembersForm from './TaskMembersForm.js';

class TasksList extends Component {
    constructor(props) {
        super(props);
        const { page, isEdit, lastInteractedId } = this.props.router.location.state || {};
        if (lastInteractedId) {
            this.props.taskStore.setLastInteractedId(lastInteractedId);
        }
        this.hasIntegrationSupport = [payrollIntegrationOptions.TRIPLETEX, payrollIntegrationOptions.XLEDGER].includes(this.props.commonStore.config?.integration_details?.product);
        this.state = {
            page: page ? page : 0,
            isPageAddedOrEdited: isEdit ? isEdit : false,
            lastColoumLoadTime: new Date(),
            isTaskHoursLoading: false,
            nowEditingId: null,
            nowEditingProjectId: null,
            showTaskImportComponent: false
        };
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    componentDidMount() {
        const { taskStore } = this.props;
        taskStore.getTaskTotals();
    }

    componentWillUnmount() {
        this.props.taskStore.clearLastInteractedId();
    }

    handleTableButtonAction = (id, type, assignee_id, project_manager_id, pmHasManageProjects) => {
        const { userStore } = this.props;
        if (type === 'edit') {
            if (!this.validateRoleAccess(assignee_id, project_manager_id, 'manage', pmHasManageProjects)) return;
            this.props.taskStore.setLastInteractedId(id);
            this.props.router.navigate(`/admin/tasks/${id}`, { state: { tasks: id, page: this.state.page, isEdit: this.state.isPageAddedOrEdited, lastInteractedId: id } });
        }
        if (type === 'remove') {
            if (!this.validateRoleAccess(assignee_id, project_manager_id, 'remove', pmHasManageProjects)) return;
            let isSelf = assignee_id === userStore.currentUser?.id ? true : false;
            return this.props.handleDelete(id, (id) => {
                return this.props.taskStore.remove(id, isSelf).then((res) => {
                    this.props.taskStore.resetLastListLoadTime();
                    return res;
                });
            });
        }
    };

    handleSyncWithIntegration = (id) => {
        const { taskStore, t, commonStore } = this.props
        const str = t(`Do You want to Sync Task with Tripletex`);
        confirmAlert({
            title: this.props.t('Confirm to Sync'),
            message: str,
            buttons: [
                {
                    label: this.props.t('Yes'),
                    onClick: () => {
                        return taskStore.saveIntoIntegration({ id: id }).then((res2) => {
                            taskStore.resetLastListLoadTime();
                            commonStore.addNotification(t(res2.message), null, 'success');
                            return res2;
                        });
                    },
                },
                {
                    label: this.props.t('No'),
                    onClick: () => { },
                },
            ],
        })
    }

    validateRoleAccess = (assignee_id, project_manager_id, action, pmHasManageProjects = false) => {
        const userStore = this.props.userStore;
        switch (userStore?.currentUser?.user_type) {
            case 'member':
                return assignee_id === userStore.currentUser.id;
            case 'pm':
                if (action !== 'remove' && pmHasManageProjects) return true;
                if (assignee_id === userStore.currentUser.id) return true;
                if (project_manager_id !== userStore.currentUser.id && action !== 'create') return false;
                return checkUserPermissions('md_Task', action);
            default:
                return true;
        }
    }

    //handles generic list page change//
    handlePageChange = (page, isEdit) => {
        this.setState({ page, isPageAddedOrEdited: isEdit });
    };

    handleHeaderTabs = (status) => {
        if (this.isHeaderTabActive(status)) return;
        this.props.taskStore.setFilter('status', status)
        this.props.taskStore.onFilter();
    }

    isHeaderTabActive = (status) => {
        const { appliedFilters } = this.props.taskStore;
        return appliedFilters.status === status
    }

    handleViewHours = async (id) => {
        const { commonStore, taskStore, userStore } = this.props;
        const { currentUser } = userStore;
        try {
            let pmMembers = '';
            if (currentUser.user_type === 'pm' && currentUser?.Manages?.length) {
                pmMembers = currentUser.Manages.join(',');
            }
            await taskStore.getTaskTotalHours(id, pmMembers);
        } catch (error) {
            console.error(error);
            commonStore.addNotification(error.message || 'Something went wrong', null, 'error');
        }
        finally {
            this.setState({ isTaskHoursLoading: false, lastColoumLoadTime: new Date() });
        }
    }

    handleImportModal = (state) => {
        this.setState({ showTaskImportComponent: state });
        this.props.taskStore.resetLastListLoadTime();
    }

    startEdit = (id, projectId) => {
        if (this.props.userStore.currentUser.user_type === 'member') return;
        this.props.taskStore.setLastInteractedId(id);
        this.setState({ nowEditingId: id, nowEditingProjectId: projectId })
    }

    afterChangeMembers() {
        this.props.taskStore.setFilter('reloadTime', new Date().toString());
        this.props.taskStore.onFilter();
        this.props.taskStore.resetLastListLoadTime();
        this.setState({ nowEditingId: null });
    }

    getRowClassName = (row) => {
        if (row.id === this.props.taskStore.lastInteractedId) return 'interacted-row';
        return '';
    };

    renderTaskHeader() {
        const { t, taskStore, commonStore } = this.props;
        const { taskCounts } = taskStore;
        const { page, isPageAddedOrEdited, showTaskImportComponent } = this.state;
        const { id: userId } = this.props.userStore.currentUser;
        const integrationSettings = commonStore?.config?.integration_details?.integration_settings;
        const showImportTaskButton = !!(commonStore?.config?.integration_details?.product === payrollIntegrationOptions.TRIPLETEX && integrationSettings?.useGeneralActivitiesForTimesheet);

        return (
            <Row className="align-content-center mt-2 gx-0">
                <Col xs={12} md={{ span: 12, offset: 0 }} lg={{ span: 7, offset: 0 }}>
                    <Row className="member_status__summary">
                        <Col
                            xs={4}
                            className="mt-2 mt-sm-0 justify-content-center justify-content-sm-end justify-content-lg-center"
                        >
                            <div className={`highlighted ${this.isHeaderTabActive("") ? 'active' : ""}`} role={'button'}
                                onClick={() => this.handleHeaderTabs("")}
                            >
                                {t('All')} {t('Tasks')}: {taskCounts.all ? taskCounts.all : '...'}
                            </div>
                        </Col>
                        <Col
                            xs={4}
                            className="mt-2 mt-sm-0 justify-content-center justify-content-sm-start justify-content-lg-center"
                        >
                            <div
                                className={`highlightedgreen ${this.isHeaderTabActive("active") ? 'active' : ""}`}
                                role={'button'}
                                onClick={() => this.handleHeaderTabs("active")}
                            >
                                {t('Active')} {t('Tasks')}: {taskCounts.active ? taskCounts.active : '...'}
                            </div>
                        </Col>
                        <Col xs={4} className="mt-2 mt-sm-0 justify-content-center">
                            <div
                                className={`highlightedred ${this.isHeaderTabActive("inactive") ? 'active' : ""}`}
                                role={'button'}
                                onClick={() => this.handleHeaderTabs("inactive")}
                            >
                                {t('Inactive')} {t('Tasks')}: {taskCounts.inactive ? taskCounts.inactive : '...'}
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col
                    xs={12} lg={5}
                    className="mt-2 mt-lg-0 text-start text-lg-end"
                >
                    <Row className="gx-0 genericlist_header_xxl_auto justify-content-lg-end" >
                        {showImportTaskButton ?
                            <Col className="text-end">
                                <Button
                                    onClick={() => this.setState((state) => ({ showTaskImportComponent: !showTaskImportComponent }))}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" className='margin-right-10'>
                                        <path fill="#2550ac" d="M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2m4 4V4h-4v2h4m-2 3l-5 5h3v4h4v-4h3l-5-5Z"></path>
                                    </svg>
                                    {this.props.t('Import')}
                                </Button>
                            </Col>
                            : null
                        }
                        <Col xs={6} sm={{ span: 4, offset: 4 }} lg={{ span: 3, offset: 0 }} className="text-end">
                            <OverlayTrigger
                                key="add-task"
                                placement="left"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {!this.validateRoleAccess(userId, null, 'create') ?
                                            this.props.t("You don't have enough rights to perform this action")
                                            : this.props.t('Add Task')}</Tooltip>}
                            >
                                <Button fill wd
                                    disabled={!this.validateRoleAccess(userId, null, 'create')}
                                    onClick={() => this.props.onAdd(page, isPageAddedOrEdited)}
                                >
                                    <i className="fa fa-plus-circle fa-xl margin-right-10" />
                                    {this.props.t('Add new')}
                                </Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }

    renderTableActionButtons = (id, full, int_id) => {
        const { t } = this.props;
        const { user_type, id: userId } = this.props.userStore.currentUser;
        const allow = (user_type === 'pm' || user_type === 'admin') && customerFeature('pm_allow_editing_all');
        const pmHasManageProjects = !!full.pm_has_manage_projects;
        const canManage = this.validateRoleAccess(full.assignee_id, full.project_manager_id, 'manage', pmHasManageProjects);
        return (
            <div className="actions-center">
                {this.hasIntegrationSupport ? int_id ?
                    <img src={getIntegrationProduct(this.props.commonStore.config?.integration_details?.product)} width={20} height={20} alt='int' title={`${this.props.t('Synced with')} ${this.props.commonStore.config?.integration_details?.product}`} />
                    :
                    (full.status === 'active' && this.props.commonStore.config?.integration_details?.product === payrollIntegrationOptions.TRIPLETEX ? <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-top">{user_type === 'member' || !canManage ?
                                t("You don't have enough rights to perform this action") : t('Sync with integration')}</Tooltip>}
                    >
                        <Button icon_sm fill title={this.props.t("Sync with integration")}
                            disabled={user_type === 'member' || !canManage}
                            onClick={() => this.handleSyncWithIntegration(id)}>
                            <img src={Sync} alt='sync' />
                        </Button>
                    </OverlayTrigger> : null)
                    :
                    null
                }
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-top">{!canManage ?
                            t("You don't have enough rights to perform this action") : t('Edit Task')}</Tooltip>}
                >
                    <Button icon_sm fill
                        onClick={() => this.handleTableButtonAction(id, 'edit', full.assignee_id, full.project_manager_id, pmHasManageProjects)}
                        disabled={!canManage}
                    >
                        <img src={Edit} alt={"edit button"} />
                    </Button>
                </OverlayTrigger>

                {(user_type !== 'member' && user_type !== 'pm' || allow) &&
                    !full.is_default_for_project && (
                        <OverlayTrigger
                            key="remove_task"
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {!this.validateRoleAccess(full.assignee_id, full.project_manager_id, 'remove', pmHasManageProjects) ?
                                        t("You don't have enough rights to perform this action")
                                        : t('Remove Task')}
                                </Tooltip>}
                        >
                            <Button
                                icon_sm_delete
                                fill
                                onClick={() => this.handleTableButtonAction(id, 'remove', full.assignee_id, full.project_manager_id, pmHasManageProjects)}
                                disabled={!this.validateRoleAccess(full.assignee_id, full.project_manager_id, 'remove', pmHasManageProjects)}
                            >
                                <img src={Delete} alt="delete button" />
                            </Button>
                        </OverlayTrigger>
                    )
                }
            </div>
        );
    };

    render() {
        const { t, commonStore, userStore, taskStore } = this.props;
        const { page, isPageAddedOrEdited, lastColoumLoadTime, isTaskHoursLoading, nowEditingId, nowEditingProjectId, showTaskImportComponent } = this.state;
        const { loading, filters, appliedFilters, taskTotalHours } = taskStore;
        const { config } = commonStore;
        const dateTimeRules = commonStore.getDateTimeRules();
        const statusOptions = config?.client?.data?.task_statuses || [];
        const { user_type } = userStore.currentUser;

        const includeIntegrationDetails = commonStore.config?.integration_details?.product
            && commonStore.config?.integration_details?.product !== payrollIntegrationOptions.VISMA ? true : false;

        return (
            <div className="table-list">
                <GenericList
                    columns={[
                        {
                            Header: '#',
                            id: 'task_number',
                            accessor: ({ task_number }) => (<span>{task_number || ''}</span>),
                            isSortable: true,
                            maxWidth: 50,
                            minWidth: 70,
                            textAlign: 'start',
                        },
                        {
                            Header: 'Task',
                            id: 'name',
                            accessor: ({ id, name, project_manager_id, assignee_id, pm_has_manage_projects }) => (
                                <span title={name}>
                                    {this.validateRoleAccess(assignee_id, project_manager_id, 'manage', !!pm_has_manage_projects) ?
                                        <button
                                            role='link'
                                            style={{ border: 0 }}
                                            className="list-main-column"
                                            onClick={() => this.handleTableButtonAction(id, 'edit', assignee_id, project_manager_id, !!pm_has_manage_projects)}
                                        >
                                            {name}
                                        </button>
                                        :
                                        <>{name}</>
                                    }
                                </span>
                            ),
                            isSortable: true,
                            minWidth: 80,
                            maxWidth: 120,
                            textAlign: "start"
                        },
                        {
                            Header: 'Project',
                            id: 'project_name',
                            accessor: ({ project_name, project_number }) => <span>{project_number ? `${project_number} | ${project_name}` : project_name}</span>,
                            minWidth: 80,
                            maxWidth: 100,
                            textAlign: "start"
                        },
                        {
                            Header: 'Last Updated',
                            id: 'updated_at',
                            accessor: ({ updated_at }) => (
                                <span>{updated_at && shortDateFormat(updated_at, dateTimeRules)}</span>
                            ),
                            isSortable: true,
                            maxWidth: 70,
                            minWidth: 70,
                            textAlign: "start"
                        },
                        {
                            Header: 'Location',
                            id: 'location',
                            sortable: false,
                            accessor: ({ address, post_place, post_number }) => (
                                <span>
                                    {`${address ? `${address} ` : ''}${post_place ? `${post_place} ` : ''}${post_number ? `${post_number} ` : ''}`}
                                </span>
                            ),
                            minWidth: 70,
                            maxWidth: 90,
                            textAlign: "start"
                        },
                        (user_type !== 'member' && {
                            Header: 'Members',
                            id: 'user_name',
                            accessor: ({ is_default_for_project, assignee_id, project_manager_id, id, project_id, pm_has_manage_projects, status }) => {
                                if (status !== 'active') return <span>-</span>;
                                return (
                                    <span>
                                        {is_default_for_project ?
                                            t("All")
                                            :
                                            <OverlayTrigger
                                                key="assign-members"
                                                placement="bottom"
                                                overlay={
                                                    <Tooltip id="tooltip-top">
                                                        {!this.validateRoleAccess(assignee_id, project_manager_id, 'manage', !!pm_has_manage_projects) ?
                                                            t("You don't have enough rights to perform this action")
                                                            : `${t('Assign')} ${t('Members')}`}</Tooltip>}
                                            >
                                                <span
                                                    role='button'
                                                    className={`m-1 projectassignbtn ${this.validateRoleAccess(assignee_id, project_manager_id, 'manage', !!pm_has_manage_projects) ? 'cursor-pointer' : 'cursor-no-drop'}`}
                                                    disabled={!this.validateRoleAccess(assignee_id, project_manager_id, 'manage', !!pm_has_manage_projects)}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (!this.validateRoleAccess(assignee_id, project_manager_id, 'manage', !!pm_has_manage_projects)) return;
                                                        this.startEdit(id, project_id)
                                                    }}
                                                >
                                                    {t('Assign')}
                                                </span>
                                            </OverlayTrigger>
                                        }
                                    </span>
                                );
                            },
                            maxWidth: 80,
                            minWidth: 60
                        }),
                        {
                            Header: 'Total Hours',
                            id: 'total_hours',
                            sortable: false,
                            accessor: ({ id }) => (<>
                                {taskTotalHours && typeof taskTotalHours[id] === 'number' ?
                                    <span>{totalTimeFormat(taskTotalHours[id], dateTimeRules)}</span>
                                    :
                                    <OverlayTrigger
                                        key="check_hours"
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">{t('Click to view total timesheet hours logged in this task')}</Tooltip>}
                                    >
                                        <span
                                            role='button'
                                            className={"m-1 projectassignbtn cursor-pointer"}
                                            disabled={isTaskHoursLoading}
                                            onClick={(e) => { e.stopPropagation(); this.props.taskStore.setLastInteractedId(id); this.setState({ isTaskHoursLoading: true }, () => this.handleViewHours(id)); }}
                                        >
                                            {t('View Hours')}
                                        </span>
                                    </OverlayTrigger>
                                }</>),
                            minWidth: 50,
                            maxWidth: 70
                        },
                        {
                            Header: 'Actions',
                            id: 'actions',
                            sortable: false,
                            accessor: (full) => this.renderTableActionButtons(full.id, full, full.int_id),
                            maxWidth: 120,
                            minWidth: 80
                        },
                    ]}
                    header={
                        <GenericFilter
                            filters={filters}
                            setFilter={(name, value) => this.props.taskStore.setFilter(name, value)}
                            onFilter={() => this.props.taskStore.onFilter()}
                            loading={loading}
                            hasStatusFilter={true}
                            statusOptions={statusOptions}
                            hasProjectFilter={true}
                            searchFilterPlaceholder={"Search by task name or number"}
                        />
                    }
                    tableHeader={t('Tasks')}
                    splitHeader={true}
                    forceReload={this.props.taskStore.deleteSuccess}
                    filters={appliedFilters}
                    lastListLoadTime={this.props.taskStore.lastListLoadTime}
                    requestData={(params) => this.props.taskStore.loadList({ ...params, includeIntegrationDetails })}
                    handlePageChange={(page, isEdit) => this.handlePageChange(page, isEdit)}
                    page={page}
                    isPageAddedOrEdited={isPageAddedOrEdited}
                    lastColoumLoadTime={lastColoumLoadTime}
                    getRowClassName={this.getRowClassName}
                    onRowClick={(row) => {
                        const current = this.props.taskStore.lastInteractedId;
                        this.props.taskStore.setLastInteractedId(current === row.id ? null : row.id);
                    }}
                >
                    {this.renderTaskHeader()}
                </GenericList>
                <Modal
                    size='lg'
                    dialogClassName="custom-big-modal modal-70w"
                    show={!!nowEditingId}
                    onHide={() => this.setState({ nowEditingId: null })}
                    className={`right modal_revised`}
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{this.props.t('Task')} {this.props.t('Members')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close_button'
                            onClick={() => this.setState({ nowEditingId: null, modalName: '' })}
                        />
                    </Modal.Header>
                    <Modal.Body style={{ minHeight: '80vh' }}>
                        <TaskMembersForm taskId={nowEditingId} projectId={nowEditingProjectId} afterSave={() => this.afterChangeMembers()} />
                    </Modal.Body>
                </Modal>
                {showTaskImportComponent &&
                    <ImportTaskFromIntegration
                        handleImportModal={this.handleImportModal}
                    />
                }
            </div>
        );
    }
}
export default inject('taskStore', 'userStore', 'commonStore')(applicationRouter(withLocalization(withRemoveDialog(observer(TasksList)))));
